export default "/images/132ff5d5b2f2656e897ece8997ab9bb0.avif";